/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import Input from "../UI/Input/Input";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Button, Card } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { InfinitySpin } from "react-loader-spinner";

class LoyalityPoint extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    //console.log(props)
    this.state = {
      items: [],
      DataisLoaded: false,
      restaurent: [],
      restaurent_outlet: [],
      restro_id: "",
      start_date: "",
      rest: "",
      end_date: "",
      type: "",
      currentPage: 1,
      totalPages: 1,
      total: "",
      per_page: 10,
      booking_status: "",
      booking_type: "",
    };
  }

  componentDidMount() {
    this.fetchloyality();
    // this.fetchData();
    this.fetchRestData();
  }

  fetchloyality() {
    axios.post(endpoints.getLoyality, {}).then((response) => {
      //console.log(response)
      this.setState({
        items: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
    });
  }

  fetchRestData() {
    axios.post(endpoints.getRestaurentsDropDown, {}).then((response) => {
      //console.log(response)
      this.setState({
        restaurent: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
    });
  }

  render() {
    const { DataisLoaded, items, total } = this.state;
    const a = this.state.items;

    const b = this.state.total;

    const links = this.state.restaurent;
    const outlets = this.state.restaurent_outlet;
    const user = localStorage.getItem("user");
    const user_data = JSON.parse(user);
    this.restro_id = user_data.restro_id;

    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1);
    const date = JSON.stringify(dates.getDate());

    const columns = [
      {
        selector: (row) => row.full_name,
        cellExport: (row) => row.full_name,
        sortable: true,
      },
      {
        selector: (row) => row.email,
        cellExport: (row) => row.email,
        // omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.mobile,
        cellExport: (row) => row.mobile,
        sortable: true,
      },
      {
        selector: (row) => row.card_holder_point,
        cellExport: (row) => row.card_holder_point,
        sortable: true,
      },

      {
        selector: (row) => row.name,
        cellExport: (row) => row.name,
        sortable: true,
      },

      {
        selector: (row) =>
          row.booking_status === "ACTION" ? (
            "ACTION"
          ) : (
            <div>
              {" "}
              <Link to={`/dashboard/loyal_detail/${row.id}`}>
                {" "}
                <Visibility />{" "}
              </Link>{" "}
            </div>
          ),
        cellExport: (row) => row.booking_status,
        sortable: true,
      },
    ];

    const onSubmit = async (e) => {
      this.filterfetch(e);
      // console.log(e)
    };

    const bFilter = async () => {
      this.setState({ items: [] });

      var mobile_number = this.mobile_number;
      var rest = this.rest;
      // console.log('working_rest', rest)
      var type = this.type;

      //console.log(items)
      axios
        .post(endpoints.getLoyality, {
          mobile_number,
          rest,
          type,
        })

        .then((response) => {
          this.setState({
            items: [""],
            items: response.data.data,

            DataisLoaded: true,
          });
        });
    };
    const onMobileNumber = (e) => {
      this.mobile_number = e.target.value;
    };

    const onTypeChange = (e) => {
      this.type = e.target.value;
    };

    const onRestChange = (e) => {
      this.rest = e.target.value;
    };
    const c = [
      {
        booking_date: "BOOKING DATE",
        booking_time: "BOOKING TIME",
        created_at: "CREATED AT",
        email: "EMAIL",
        full_name: "NAME",
        mobile: "MOBILE NUMBER",
        card_holder_point: "POINTS",
        name: "RESTAURANT",
        booking_status: "ACTION",
      },
    ];

    const data = c.concat(a);
    const tableData = {
      columns,
      data,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Loyalty Point Details</h2>
        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <Input
                  id="mobile_number"
                  label="Mobile Number"
                  type="text"
                  name="mobile_number"
                  place="Enter Mobile Number"
                  onChange={(e) => onMobileNumber(e)}
                  requiredInput="required"
                />
              </div>

              <div className="col-md-3">
                <label>Filter By Ponits</label>
                <select
                  name="status"
                  required
                  className="form-control"
                  onChange={(e) => onTypeChange(e)}
                >
                  <option value="undefined">Select</option>
                  <option value="ASC">Asscending</option>
                  <option value="DESC">Decending</option>
                </select>
              </div>

              {this.restro_id === 0 ? (
                <div className="col-md-3">
                  <label>Restaurant</label>
                  <select
                    name="rest"
                    required
                    className="form-control"
                    onChange={(e) => onRestChange(e)}
                  >
                    <option value="undefined">Select Restaurant</option>
                    {links.map((e, key) => {
                      return (
                        <option key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : (
                ""
              )}
              <div className="col col-3">
                <div className="mt-5 text-center">
                  <Button
                    className="w-50"
                    onClick={() => bFilter()}
                    variant="contained"
                    size="medium"
                  >
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Card>
        <div className="row mt-2">
          <DataTableExtensions {...tableData} filter={false}>
            <DataTable
              defaultSortField="id"
              pagination
              paginationPerPage={7}
              paginationRowsPerPageOptions={[7, 14, 21, 28, 35]}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default withRouter(LoyalityPoint);
